import api from './api';
import type { ConversionRow } from '../types';

export async function getConversions(
  from: string,
  to: string,
  limit = 50,
  offset = 0,
): Promise<{ items: ConversionRow[]; total: number }> {
  const { data } = await api.get('/partner/conversions', {
    params: { from, to, limit, offset },
  });
  return { items: data.data, total: data._meta?.total ?? 0 };
}

export async function getAllConversions(from: string, to: string): Promise<ConversionRow[]> {
  const all: ConversionRow[] = [];
  const batchSize = 1000;
  let offset = 0;
  let total = Infinity;

  while (offset < total) {
    const result = await getConversions(from, to, batchSize, offset);
    all.push(...result.items);
    total = result.total;
    offset += batchSize;
  }

  return all;
}
